import { axiosInstance } from "../../../api/axiosInstance";
import { PERSON_APIS } from "../../../modules/common/api/apis";
import { Person, PersonPage } from "../types";

export async function createPerson(data: Person): Promise<number> {
  const response = await axiosInstance.post(PERSON_APIS.PERSONS, data);
  return response.status;
}

export async function getPersons(page: number, size: number): Promise<PersonPage> {
  const response = await axiosInstance.get<PersonPage>(`${PERSON_APIS.PERSONS}?view=list&page=${page}&size=${size}`);
  return response.data;
}

export async function getPersonDetails(externalId: number): Promise<Person> {
  const response = await axiosInstance.get<Person>(`${PERSON_APIS.PERSONS}?view=details&externalId=${externalId}`);
  return response.data;
}

export async function searchPersons(name: string, mobileNo: string): Promise<PersonPage> {
  const params = new URLSearchParams();
  params.set("view", "list");
  params.set("page", "0");
  params.set("size", "50");
  if (name) params.set("name", name);
  if (mobileNo) params.set("mobileNo", mobileNo);
  const response = await axiosInstance.get<PersonPage>(`${PERSON_APIS.PERSONS}?${params.toString()}`);
  return response.data;
}

export async function updatePerson(externalId: number, changedFields: Partial<Person>): Promise<Person> {
  const response = await axiosInstance.patch<Person>(`${PERSON_APIS.PERSONS}/${externalId}`, changedFields);
  return response.data;
}

export async function deletePerson(externalId: number): Promise<void> {
  await axiosInstance.delete(`${PERSON_APIS.PERSONS}/${externalId}`);
}
